import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { CostCenterByLocation } from '../cost-center-by-location/cost-center-by-location';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { RegionService } from '../proxy/planning/controllers/region.service';
FieldBuilder.setNamespace('Planning');

export const THIRDPARTYDESTINATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('locationId', 'Entity.Location', LocationService)
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.text('name', 'Entity.ThirdPartyDestination.Name')
    .required()
    .build(),
  FieldBuilder.foreignKey('regionId', 'Entity.Region', RegionService)
    .displayFromNested('region.name')
    .sortBy('region.name')
    .build(),
  FieldBuilder
    .number('capacity', 'Entity.ThirdPartyDestination.Capacity')
    .decimal(2,9)
    .build(),
  FieldBuilder
    .checkbox('isShip', 'Entity.ThirdPartyDestination.IsShip')
    .build(),
  FieldBuilder
    .checkbox('isEligibleForElectronicInvoice', 'Entity.ThirdPartyDestination.IsEligibleForElectronicInvoice')
    .build(),
  FieldBuilder
    .checkbox('isDestinationWoodLog', 'Entity.ThirdPartyDestination.IsDestinationWoodLog')
    .build(),
  FieldBuilder
    .checkbox('demandSaleContract', 'Entity.ThirdPartyDestination.DemandSaleContract')
    .build(),
  FieldBuilder
    .checkbox('isTransferLogyard', 'Entity.ThirdPartyDestination.IsTransferLogyard')
    .build(),
];

export const THIRDPARTYDESTINATION_CONFIG = {
  entityName: 'ThirdPartyDestination',
  localizationKey: 'Planning::Entity.ThirdPartyDestination',
  fields: THIRDPARTYDESTINATION_FIELDS,
  permission: 'PlanningLocation.ThirdPartyDestinations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'CostCenterByLocation',
      foreignKeyField: 'locationId',
      localizationKey: 'Planning::Entity.CostCenterByLocation',
      component: CostCenterByLocation,
    },
  ],
};
